<template>
  <div>
    <common-dialog
      ref="dialog"
      width="800px"
      title="查看 校讯通设置"
      id-key="EduToHomeId"
      form-label-width="140px"
      @details-opened="onDetailsOpened"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="启用学校">{{data.SchoolName}}</el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="月收费">{{data.MonthCharge}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="开始计费月份">{{data.StartMonth}}</el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="截止计费月份">{{data.EndMonth}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="开始充值月份">{{data.RechargeMonth}}</el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="一次性收费">
              <span>{{data.TotalMonth}}个月、{{data.TotalCharge}}元</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="每月通话次数上限">{{data.MonthCountLimit}}次</el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="每次通话时长上限">{{data.SingleDurationLimit}}分钟</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="状态">{{data.Status==0?"禁用":"启用"}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="收费规则及服务内容">{{data.Remark}}</el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        EduToHomeId: 0,
        SchoolId: null,
        SchoolName: "",
        MonthCharge: null,
        StartMonth: "",
        StartMonthDate: null, //开始计费月份1号日期
        EndMonth: "",
        EndMonthDate: null, //截止计费月份最后一天日期
        RechargeMonth: "",
        RechargeMonthDate: null, //开始充值月份1号日期
        TotalMonth: null,
        TotalCharge: null,
        MonthCountLimit: null,
        SingleDurationLimit: null,
        Status: 1, // 0:停用 1:启用
        Remark: "",
      },
      api: require("@/api/consume/edutohome").default,
      isMB: this.$store.state.isMB,
    };
  },
  computed: {},
  methods: {
    onDetailsOpened(data) {
      // console.log("details", data);
      this.data = { ...data };
    },
  },
};
</script>
<style lang="scss">
</style>